import { action } from "easy-peasy";

export const somethingModel = {
  popupShow: null,
  menuActive: false,
  hoverIndex: null,
  error: null,
  setHoverIndex: action((state, payload) => {
    state.hoverIndex = payload;
  }),
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setPopup: action((state, payload) => {
    state.popupShow = payload;
  }),
  setMenuActive: action((state, payload) => {
    state.menuActive = payload;
  }),
};
